export default __webpack_public_path__ + "static/media/coming_soon.e3f97717.jpg";